import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * menuInfo의 proId에 따라 routeConfig에서 컴포넌트 선택 (MultiTrainingPage와 동일)
 */
export function DynamicRouteWrapper({ menuId, path, components }) {
  const navigate = useNavigate();
  const menuInfo = useSelector((state) => state.BaseInfo.menuInfo);

  let componentMap = components;
  if (!components) {
    try {
      const { getComponentMapForMenu } = require('./routeConfig');
      componentMap = getComponentMapForMenu(menuId, path);
    } catch (e) {
      console.warn(
        'routeConfig를 불러올 수 없습니다. components prop을 사용하세요.'
      );
    }
  }

  const menu = menuInfo?.find((m) => m.menuId === menuId);

  useEffect(() => {
    if (menu) return;
    navigate('/Home', { replace: true });
  }, [menu, navigate]);

  if (!componentMap) {
    console.error(
      `컴포넌트 매핑을 찾을 수 없습니다. menuId: ${menuId}, path: ${path}`
    );
    return null;
  }

  if (!menu) return null;

  const componentKey = menu.proId || 'default';
  const Component = componentMap[componentKey] || componentMap.default;

  if (!Component) {
    console.error(
      `컴포넌트를 찾을 수 없습니다. menuId: ${menuId}, path: ${path}, componentKey: ${componentKey}`,
      '사용 가능한 키:',
      Object.keys(componentMap)
    );
    return null;
  }

  return <Component />;
}
